import { useMutation } from '@tanstack/react-query';
import { useChatApiClient } from '@trinity/chat-components/containers/Chat/useApiClient.js';
import type { TagExtractionPrompt } from '@trinity/chat/api/interfaces/projects';
import { useInvalidateProjectTagsQuery } from './useInvalidateTagsQuery';

type UpdatePromptsParams = {
  tagId: number;
  summary?: string[];
  extraction?: TagExtractionPrompt[];
};

export const useUpdateTagPromptsMutation = (projectId: number) => {
  const apiClient = useChatApiClient();
  const invalidateTagsQuery = useInvalidateProjectTagsQuery(projectId);

  return useMutation({
    mutationFn: ({ tagId, summary, extraction }: UpdatePromptsParams) =>
      apiClient.projects.updateProjectTagPrompts({
        projectId,
        projectTagId: tagId,
        summary,
        extraction,
      }),
    onSuccess: () => {
      invalidateTagsQuery();
    },
    onError: (error) => {
      console.error('Error updating project tag prompts:', error);
    },
  });
};
